import { v4 as uuidv4 } from 'uuid';
import { request } from '@/api/request';
import OSS from 'ali-oss';
import SparkMD5 from 'spark-md5';
import { isArray } from 'lodash';
import { api_config } from '@/constants/api';
// let client: any;
let ossBucket = '';
let ossRegion = '';
let file_prefix = '';
const API_URL = api_config.API_URL;
const uidAndTime = `${uuidv4()}-${Date.parse(new Date())}`;
file_prefix = 'static/' + getNowFormatDate() + '/' + uidAndTime + '/input/';
let ext;
let curEnv =
  process.env.NODE_ENV === 'development' ||
  process.env.REACT_APP_BUILD_ENV === 'development'
    ? 'dev'
    : 'prod';
if (curEnv === 'dev') {
  ossBucket = 'piccutout-sgp-test';
  ossRegion = 'oss-ap-southeast-1';
} else {
  ossBucket = 'piccutout-sgp-prod';
  ossRegion = 'oss-ap-southeast-1';
}

export const client = async () => {
  const data = await getClientData();
  if (data.code === 200) {
    const client = new OSS({
      secure: true, // secure: 配合region使用，如果指定了secure为true，则使用HTTPS访问
      accessKeyId: data.data.accessKeyId,
      accessKeySecret: data.data.accessKeySecret,
      bucket: data.data.bucket,
      stsToken: data.data.stsToken,
      region: data.data.region,
    });
    return {
      code: 200,
      data: client,
    };
  } else {
    return data;
  }
};

// 阿里云获取授权
const getClientData = async () => {
  const options = {
    method: 'POST',
  };
  let data = await request(API_URL + '/security-token/v3', options);
  if (data.data.prefix) {
    file_prefix = data.data.prefix;
  }
  if (data.code === 200) {
    const option = {
      secure: true, // secure: 配合region使用，如果指定了secure为true，则使用HTTPS访问
      accessKeyId: data.data.access_key_id,
      accessKeySecret: data.data.access_key_secret,
      bucket: ossBucket,
      stsToken: data.data.security_token,
      region: ossRegion,
    };
    return {
      data: option,
      code: 200,
    };
  } else if (data.code === 401) {
    return {
      data: '',
      code: 401,
    };
  } else if (data.code === 500) {
    return {
      data: '',
      code: 500,
    };
  } else {
    return {
      data: '',
      code: 'error',
    };
  }
};

let _fileStart;
/**
 * client: 上传实例
 * file 当前上传的文件
 * fileStart 当前文件的的信息
 * chunkSize： 分片大小
 * getProgress： 进度方法
 */
export const multipartUpload = async (
  client,
  file,
  fileStart,
  chunkSize, // 2 * 1024 * 1024
  getProgress
) => {
  _fileStart = fileStart;
  ext = file.raw
    ? file.raw.name.substring(file.raw.name.lastIndexOf('.'))
    : file.name.substring(file.name.lastIndexOf('.'));
  return new Promise(async (resolve, reject) => {
    let fileMd5 = await fileMd5Func(file, chunkSize);
    let filePath = `/${file_prefix}${fileMd5}${ext}`;
    uploadGa(file);
    uploader();
    async function uploader() {
      const headers = {
        'x-oss-object-acl': 'public-read',
      };
      const options = {
        // 获取分片上传进度、断点和返回值。
        progress: (p, cpt) => {
          console.log(_fileStart, 'fileStart');
          if (_fileStart.isCancel) {
            client.cancel();
          }
          getProgress && getProgress(p);
          localStorage.setItem(fileMd5, JSON.stringify(cpt));
        },
        // 设置并发上传的分片数量。
        parallel: 4,
        // 设置分片大小。默认值为1 MB，最小值为100 KB。
        partSize: chunkSize,
        headers,
        // 自定义元数据，通过HeadObject接口可以获取Object的元数据。
        meta: { year: 2020, people: 'test' },
        mime: file.raw ? file.raw.type : file.type,
      };
      try {
        if (localStorage.getItem(fileMd5)) {
          const checkPoint = localStorage.getItem(fileMd5);
          console.log('我走断点续传');
          options.checkpoint = checkPoint;
        }
        const result = await client.multipartUpload(
          filePath,
          file.raw ? file.raw : file,
          {
            ...options,
          }
        );
        const res = result.res;
        localStorage.removeItem(fileMd5);
        if (res?.status == 200) {
          let uploadFileUrl = res.requestUrls[0].indexOf('?')
            ? res.requestUrls[0].split('?')[0]
            : res.requestUrls[0];
          let endUpload = Math.round(
            (new Date().getTime() - beginUpload) / 1000
          );
          resolve({
            code: 200,
            data: {
              uploadProgress: 100,
              uploadFileUrl,
              gaobj: {
                time: endUpload,
                gafileExtension: gafileExtension,
                gafileSize: gafileSize,
              },
            },
          });
        }
      } catch {
        resolve({
          code: 'error',
          data: {
            isCancel: _fileStart.isCancel ? _fileStart.isCancel : '',
          },
        });
      }
    }
  });
};

/**
 *
 * @param client 上传实例
 * @param file 批量上传的文件
 * @param fileStart 当前上传文件的状态的对象
 * @param getProgress： 进度方法
 * @returns
 */
let isCancel = false;
export const batchPutImgs = async (client, file, fileStart, getProgress) => {
  _fileStart = fileStart;
  isCancel = false;
  return new Promise(async (resolve, reject) => {
    let count = 0;
    let uploadUrl = [];
    function singlePut() {
      let filename = uuidv4(),
        ext = file[count].raw
          ? file[count].raw.name.substring(
              file[count].raw.name.lastIndexOf('.')
            )
          : file[count].name.substring(file[count].name.lastIndexOf('.')),
        filePath = `/${file_prefix}${filename}${ext}`;
      uploadGa(file[count]);
      fileUploadRequest();
      async function fileUploadRequest() {
        try {
          const headers = {
            'x-oss-object-acl': 'public-read',
          };
          const options = {
            // 获取分片上传进度、断点和返回值。
            progress: (p, cpt) => {
              isCancel = _fileStart.some((item) => {
                return item.isCancel === true;
              });
              if (isCancel) {
                client.cancel();
              }
              getProgress && getProgress((p + count) / file.length);
            },
            // 设置并发上传的分片数量。
            parallel: 4,
            // 设置分片大小。默认值为1 MB，最小值为100 KB。
            partSize: 1 * 1024 * 1024,
            headers,
            // 自定义元数据，通过HeadObject接口可以获取Object的元数据。
            meta: { year: 2020, people: 'test' },
            mime: file.raw ? file.raw.type : file.type,
          };
          const result = await client.multipartUpload(
            filePath,
            file[count].raw ? file[count].raw : file[count],
            {
              ...options,
            }
          );
          const res = result.res;
          if (res?.status === 200) {
            const uploadFileUrl = res.requestUrls[0];
            // 上传成功ga
            let endUpload = Math.round(
              (new Date().getTime() - beginUpload) / 1000
            );
            uploadUrl.push(uploadFileUrl);
            if (count < file.length - 1) {
              if (!isCancel) {
                count += 1;
                singlePut();
              }
            } else {
              if (!isCancel) {
                resolve({
                  code: 200,
                  data: {
                    uploadProgress: 100,
                    uploadFileUrl: uploadUrl,
                    gaobj: {
                      time: endUpload,
                      gafileExtension: gafileExtension,
                      gafileSize: gafileSize,
                    },
                  },
                });
              } else {
                resolve({
                  code: 'error',
                  data: {
                    isCancel: isCancel ? isCancel : '',
                  },
                });
                client.client();
              }
            }
          }
        } catch (e) {
          resolve({
            code: 'error',
            data: {
              isCancel: isCancel ? isCancel : '',
            },
          });
        }
      }
    }
    if (!isCancel) {
      singlePut();
    }
  });
};

// // 上传Ga相关
let beginUpload, gafileExtension, gafileSize;
function uploadGa(file) {
  beginUpload = new Date().getTime();
  gafileExtension = ext;
  gafileSize =
    (file.raw && file.raw.size ? file.raw.size : file.size) / 1024 / 1024 > 1
      ? Math.round((file.raw ? file.raw.size : file.size) / 1024 / 1024)
      : '1';
}

function getNowFormatDate() {
  let date = new Date(),
    year = date.getFullYear(), //获取完整的年份(4位)
    month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
    strDate = date.getDate(); // 获取当前日(1-31)
  if (month < 10) month = `0${month}`; // 如果月份是个位数，在前面补0
  if (strDate < 10) strDate = `0${strDate}`; // 如果日是个位数，在前面补0

  return `${year}-${month}-${strDate}`;
}

const fileMd5Func = async (file, chunkSize = 1024 * 1024 * 50) => {
  return new Promise((resolve, reject) => {
    // 需要分片
    let chunks = Math.ceil(
        (file.raw && file.raw.size ? file.raw.size : file.size) / chunkSize
      ),
      currentChunk = 0,
      spark = new SparkMD5.ArrayBuffer(),
      fileReader = new FileReader();
    fileReader.onload = (e) => {
      spark.append(e.target?.result);
      currentChunk++;

      if (chunks && currentChunk < chunks) {
        loadNext();
      } else {
        let md5 = spark.end();
        localStorage.setItem('md5', md5);
        resolve(md5);
      }
    };
    const loadNext = () => {
      const size = file.raw && file.raw.size ? file.raw.size : file.size;
      let start = currentChunk * chunkSize,
        end = start + chunkSize >= size ? size : start + chunkSize;
      const fileObj = file.raw && file.raw.size ? file.raw : file;
      fileReader.readAsArrayBuffer(fileObj.slice(start, end));
    };
    loadNext();
  });
};

export const ossCancel = (index = 0) => {
  if (!_fileStart) return false;
  if (isArray(_fileStart)) {
    _fileStart = _fileStart[index].isCancel = true;
  } else {
    _fileStart.isCancel = true;
  }
};

export const downloadPreSign = async (url) => {
  const formData = new FormData();
  formData.append('preSign-url', url);
  const options = {
    body: formData,
    method: 'POST',
  };

  let data = await request(API_URL + '/downloadPreSign', options);
  return data;
};
